import { SagaIterator } from 'redux-saga';
import { all, fork } from 'redux-saga/effects';
import memberListSaga from 'features/member/saga/memberListSaga';
import connectMemberListSaga from 'features/member/saga/connectMemberListSaga';
import memberDetailSaga from 'features/member/saga/memberDetailSaga';
import memberClosetSaga from 'features/member/closet/saga/memberClosetSaga';

function* memberRootSaga(): SagaIterator {
  yield all([
    fork(memberListSaga),
    fork(connectMemberListSaga),
    fork(memberDetailSaga),
    fork(memberClosetSaga),
  ]);
}

export default memberRootSaga;
